import React from 'react';

import classes from './AccountSetupBanner.module.scss';
import { SwymoLogo } from '../../../../shared/components/SwymoLogo/SwymoLogo';

const AccountSetupBanner = () => {
  return (
    <div className={classes.container}>
      <SwymoLogo variant="white" className={classes.logo} />
      <p className={classes.title}>Welcome to Account Setup</p>
      <p className={classes.description}>
        Get started on the right foot! Follow the checklist
        <br />
        for new Coaches below to get started.
      </p>
    </div>
  );
};

export { AccountSetupBanner };
